import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, IHorizontalBarChart, TagDefinition, ConnectionPoint, BadActor } from '../../models';
import { BadActorsBase } from './badActorsBase';
import { tagDefaultState } from '../../common/';
import { IBadActorsWidget } from './badActorsWidgetBase';

interface IBadActors extends IHorizontalBarChart {
    isLoading: boolean;
}

class BadActorsController extends BadActorsBase implements IBadActors {
    static controllerId = 'BadActors';
    item: IBadActorsWidget;
    tagsDictionary: { [guid: string]: TagDefinition; };
    connectionPointsDictionary: { [guid: string]: ConnectionPoint; };
    isLoaded: boolean;
    private __scope: angular.IScope;

    static $inject = ['$scope', '$state'];
    constructor($scope: angular.IScope,
        private _$state: angular.ui.IStateService) {
        super($scope);
        this.__scope = $scope;
    }

    $onInit() {
        super.$onInit();
        if (this.item.options) {
            if (this.item.options.seriesClick) {
                this.options.seriesClick = this.item.options.seriesClick;
            }
        } else {
            this.options = {
                seriesClick: (d, i) => {
                    this._$state.go(tagDefaultState, { tagDefinitionGuid: d.guid });
                }
            };
        }
        const self = this;
        self.readData();

        this.__scope.$watch(() => this.isLoaded, () => {
            if (this.isLoaded) {
                this.updateLabels(this.data);
            }
        });
    }

    readData(guid?: string) {
        const self = this;
        self.isLoading = true;
        self.item
            .readData(guid)
            .then((data) => {
                self.data = data;
                if (self.data) {
                    self.data.forEach((d, i) => {
                        d.status = i;
                    });
                    this.updateLabels(self.data);
                }
            })
            .finally(() => this.isLoading = false);
    }

    updateLabels(data: BadActor[]) {
        const self = this;
        if (data) {
            data.forEach((d, i) => {
                if (self.item.type === 'badActorsMissing') {
                    if (this.tagsDictionary && this.tagsDictionary[d.guid]) {
                        d.name = this.tagsDictionary[d.guid]?.name;
                    }
                } else if (self.item.type === 'badActorsByConnectionPointMissing') {
                    if (this.connectionPointsDictionary && this.connectionPointsDictionary[d.guid]) {
                        d.name = this.connectionPointsDictionary[d.guid]?.name;
                    }
                }
            });
            this.labels = _.map(data, 'name');
        }
    }
}
export const wtBadActors: ComponentDefinition = {
    componentId: 'wtBadActors',
    controller: BadActorsController,
    template: require('./badActors.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        tagsDictionary: '<?',
        connectionPointsDictionary: '<?',
        isLoaded: '<?'
    }
};
